'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.small.withConfig({
  componentId: 's1409c0k-0'
})(['color:', ';font-size:0.8em;vertical-align:top;'], function (p) {
  return p.theme.requiredColor;
});